import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { storesApi } from "../../api";

interface PrivacyPolicyState {
    content: string | null;
    loading: boolean;
    error: string | null;
}

const initialState: PrivacyPolicyState = {
    content: null,
    loading: false,
    error: null,
};

export const fetchPrivacyPolicy = createAsyncThunk(
    'privacyPolicy/fetchPrivacyPolicy',
    async (_, { rejectWithValue }) => {
        try {
            const response = await storesApi.getPrivacyPolicy();
            return response.data.content;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch privacy policy');
        }
    }
);

const privacyPolicySlice = createSlice({
    name: 'privacyPolicy',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPrivacyPolicy.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPrivacyPolicy.fulfilled, (state, action) => {
                state.loading = false;
                state.content = action.payload;
            })
            .addCase(fetchPrivacyPolicy.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default privacyPolicySlice.reducer;

